var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Oops!")]),_c('div',[_vm._v("A wrong URL was entered. "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Go back to the home page")]),_vm._v(".")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }